import React, { useState } from "react";
import { GetList } from "../../../hook/getList.tsx";
import { Checkbox, Modal, Popconfirm, Spin, Table, type TableColumnsType } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { request } from "../../../api/request.tsx";
import UpdateBanner from "../update-banner/index.tsx";

//

const ListBanner = () => {
  const [typeBanner, setTypeBanner] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [infoUpdate, setInfoUpdate] = useState<any>(undefined);
  const [isReload, setIsReload] = useState(false);

  const { data, loading } = GetList<any>({
    url: `banner/get-home-banner?type=${typeBanner}`,
    dependencies: typeBanner,
    dependencies1: isReload,
  });

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  //

  // new
  const columns: TableColumnsType<any> = [
    {
      title: "Hình ảnh",
      dataIndex: "url",
      key: "url",
      width: 120,
      render: (text: string) => (
        <div>
          <img 
            src={text?.replace(
              "http://27.71.26.120",
              "https://phototimevn.com"
            )} 
            alt="Banner" 
            className="lg:w-32 w-28 object-contain rounded"
          />
        </div>
      ),
    },
    {
      title: "Tên",
      dataIndex: "name",
      key: "name",
      width: 150,
      render: (text: string, record: any) => (
        <div>
          <div className="font-semibold">{text || 'Unnamed Banner'}</div>
          {record.nameEn && (
            <div className="text-xs text-gray-500">EN: {record.nameEn}</div>
          )}
          {record.nameKo && (
            <div className="text-xs text-gray-500">KO: {record.nameKo}</div>
          )}
        </div>
      ),
    },
    // {
    //   title: "Loại",
    //   dataIndex: "type",
    //   key: "type",
    //   width: 80,
    //   render: (type: number) => (
    //     <span className="inline-block bg-pink-100 text-pink-800 text-xs px-2 py-1 rounded-full">
    //       {type}
    //     </span>
    //   ),
    // },
    {
      title: "Mô tả",
      dataIndex: "description",
      key: "description",
      width: 200,
      render: (text: string, record: any) => (
        <div className="max-w-xs">
          {text && (
            <div className="text-sm line-clamp-2">{text}</div>
          )}
          {record.descriptionEn && (
            <div className="text-xs text-gray-500 line-clamp-1">EN: {record.descriptionEn}</div>
          )}
          {record.descriptionKo && (
            <div className="text-xs text-gray-500 line-clamp-1">KO: {record.descriptionKo}</div>
          )}
        </div>
      ),
    },
    {
      title: "Index",
      dataIndex: "index",
      key: "index",
      width: 80,
      sorter: (a: any, b: any) => a.index - b.index,
    },
    {
      title: "Ngày tạo",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 120,
      render: (text: string) => (
        <div className="text-xs">
          {new Date(text).toLocaleDateString('vi-VN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
          })}
        </div>
      ),
      sorter: (a: any, b: any) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
    },
    {
      title: "Ngày cập nhật",
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: 120,
      render: (text: string) => (
        <div className="text-xs">
          {new Date(text).toLocaleDateString('vi-VN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
          })}
        </div>
      ),
      sorter: (a: any, b: any) => new Date(a.updatedAt).getTime() - new Date(b.updatedAt).getTime(),
    },
    {
      title: "Hành động",
      key: "actions",
      width: 150,
      fixed: 'right',
      render: (_: any, record: any) => (
        <div className="flex gap-2">
          <button
            onClick={() => {
              showModal();
              setInfoUpdate(record);
            }}
            className="px-3 py-1 bg-blue-400 text-white rounded text-xs"
          >
            Sửa
          </button>
          <Popconfirm
            title="Xoá banner"
            description="Bạn có chắc muốn xoá banner này không?"
            okText="Xác nhận"
            cancelText="Không"
            onConfirm={async () => {
              console.log("ok === ");
              const response = await request(
                "/banner/delete-home-banner",
                {
                  id: record?.id,
                },
                "POST"
              );
              console.log("response ==== ", response);
              if (response?.status) {
                setIsReload(!isReload);
              }
            }}
          >
            <button className="px-3 py-1 bg-red-500 text-white rounded text-xs">
              Xoá
            </button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    // <div className="grid gap-2 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5">
    //   {data?.length > 0 && data?.map(renderUser)}
    // </div>
    <>
      <Modal
        closable={{ "aria-label": "Custom Close Button" }}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        width="90%"
        style={{ maxWidth: '800px' }}
        styles={{
          body: {
            maxHeight: '80vh',
            overflowY: 'auto',
            padding: '20px'
          }
        }}
      >
        <UpdateBanner
          handleCancel={handleCancel}
          setIsReload={setIsReload}
          isReload={isReload}
          infoUpdate={infoUpdate}
        />
      </Modal>
      <div className="flex flex-col gap-4">
        <div className="text-2xl text-center text-[pink] font-bold">
          DANH SÁCH VÀ CẬP NHẬT BANNER
        </div>
        <div className="flex items-center xl:gap-6 lg:gap-5 gap-3 max-lg:flex-col">
          <Checkbox
            checked={typeBanner === 1}
            onChange={() => setTypeBanner(1)}
            className="text-[pink] font-semibold"
          >
            Trang Chủ
          </Checkbox>
          <Checkbox
            checked={typeBanner === 2}
            onChange={() => setTypeBanner(2)}
            className="text-[pink] font-semibold"
          >
            Shopping mall
          </Checkbox>
        </div>
        {loading ? (
          <Spin indicator={<LoadingOutlined spin />} size="large" />
        ) : (
          <div className="overflow-x-auto">
            <Table<any>
              // rowSelection={{ type: selectionType, ...rowSelection }}
              columns={columns}
              dataSource={data}
              rowKey={(record) => record.id}
              scroll={{ x: 1200 }}
              pagination={{
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                showTotal: (total, range) => 
                  `${range[0]}-${range[1]} của ${total} banner`,
              }}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default ListBanner;
